import React, { Fragment } from 'react';
import Modal from 'react-modal';
import Input from '../../../TravellerContactInfo/FormFields/Input';
import '../../LoginModals.css';
import { useEmailAndMobileNotVerifiedContainer } from '../EmailAndMobileNotVerifiedContainer';
import { customStyles, UserFlowModalState } from '../../../UserFlow/UserFlowModal';

const EmailAndMobileNotVerified = (props: UserFlowModalState) => {
  const {
    props: {
      showModal,
      state,
      userStatus,
      errorMessage,
    },

    action: {
      rotateLoader,
      closeModal,
      goToIRCTCRegistrationPage,
      goToForgotUsernamePage,
      handleInputKeyUpViaParentEmail,
      handleInputKeyUpViaParentMobile,
    },
  } = useEmailAndMobileNotVerifiedContainer(props);

  const { userId } = userStatus;
  const {
    resendOtpEnabled,
    rotate,
    disabledByEmail,
    disabledByMobile,
    validationFail,
  } = state;
  return (
    <Fragment>
      <Modal
        isOpen={showModal}
        ariaHideApp={false}
        onRequestClose={closeModal}
        className={`loginModals loginModals--v2 loginModals--exWidth${errorMessage ? '--error' : ''}`}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            backgroundColor: 'rgb(0, 0, 0, 0.6)',
            zIndex: 1,
          },
          customStyles,
        }}
      >
        <p className={'makeFlex spaceBetween appendBottom10'}>
          <span className={'modalTitle font26 latoBlack blackText'}>
              Enter IRCTC Username
          </span>
          <span
            className="modalClose railSprite crossIcon"
            onClick={closeModal}>
          </span>
        </p>
        <p className={'additionalInfo  font14'} style={{ padding: 10 }}>
              IRCTC username <span className="blackText">will be required after Payment</span>. Please ensure you have entered correct username.
        </p>
        <div className={'makeFlex column spaceBetween'}>
          <div className='appendTop20'>
            <Input
              labelName="Enter IRCTC Username"
              validationFail={false}
              type="text"
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg=""
              vaidationMoreMsg={null}
              vaidationMoreStatus={false}
              vaidationStatus={true}
              readOnly={true}
              value={userId}
            />
          </div>
          <p className={'blackText font14 appendTop30'}>Your email is not verified. Please enter the OTP sent to your email id.</p>
          <div className="appendTop15">
            <Input
              errorMessage={errorMessage ? (errorMessage || 'No special characters allowed other than \'_\'') : 'Please enter OTP.'}
              validationFail={errorMessage}
              type="text"
              additionalAttributes={{ placeholder: 'Enter Email OTP' }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg=""
              vaidationMoreMsg={null}
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly={false}
              textStyle={'blackText latoBold font14 InputFieldElement'}
              handleInputKeyUpViaParent={handleInputKeyUpViaParentEmail}
            />
          </div>
          <p className={'blackText font14 appendTop30'}>Your mobile is not verified. Please enter the OTP sent to your registered mobile.</p>
          <div className="appendTop15">
            <Input
              errorMessage={errorMessage ? (errorMessage || 'No special characters allowed other than \'_\'') : 'Please enter OTP.'}
              validationFail={errorMessage}
              type="text"
              additionalAttributes={{ placeholder: 'Enter Mobile OTP' }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg=""
              vaidationMoreMsg={null}
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly={false}
              textStyle={'blackText latoBold font14 InputFieldElement'}
              handleInputKeyUpViaParent={handleInputKeyUpViaParentMobile}
            />
          </div>
          <button
            onClick={rotateLoader}
            className={`${(disabledByEmail || disabledByMobile) ? 'disabled appendTop20' : ''} noShrink appendTop20`}>
            <span className={`${rotate ? 'btnLoader' : 'font12 latoBlack capText'}`}>
                Submit
            </span>
          </button>
        </div>
        <p className='hrtlSeperater'></p>
        <div className='column' style={{ marginBottom: -80 }}>
          <p className='appendBottom20'><a className='font16 latoBold ' onClick={goToForgotUsernamePage}>Forgot Username</a></p>
          <p><a className='font16 latoBold ' onClick={goToIRCTCRegistrationPage}>Create New Account</a></p>
        </div>
      </Modal>
    </Fragment>
  );
};
export default EmailAndMobileNotVerified;
